export const PRE_SIGNED_URL_UPLOAD_PURPOSE_RESUME = "ResumeUpload";
export const PRE_SIGNED_URL_UPLOAD_PURPOSE_FILE = "FileUpload";
export const PRE_SIGNED_URL_FILE_TYPE_PDF = "Pdf";
export const PRE_SIGNED_URL_FILE_TYPE_IMAGE = "ImageJpeg";
export const PRE_SIGNED_URL_FILE_TYPE_DOCX = "OfficeDocx";
export const PRE_SIGNED_URL_FILE_TYPE_DOC = "OfficeDoc";
